/**
 * The plans a company can be on (LB-6228) and what each includes, for the tier badge's info tip (PRD V3, FR-11).
 * The wording is PRD V3's proposal and is still to agree with Haley (Q17), so it lives here and nowhere else.
 */
export const SUBSCRIPTION_TIERS = {
  Pro: {
    name: 'Pro',
    tip: 'Upload one bill at a time while billing a utility in Property allocation, and Livable reads it for you. Your bills show on the Bills page; uploading there, and email-in, come with Plus.'
  },
  Plus: {
    name: 'Plus',
    tip: "Email bills to your company's intake address, or upload many at once on the Bills page. Livable reads each bill, and your team allocates and approves. Applies to all your properties."
  },
  Autopilot: {
    name: 'Autopilot',
    tip: 'Everything in Plus. Livable also fetches bills from your utility portals and does the allocation and approvals for you. Applies to all your properties.'
  }
};

/** The tier the route named, or null for anything else: a name this screen doesn't know shows no badge. */
export const tierOf = name => Object.prototype.hasOwnProperty.call(SUBSCRIPTION_TIERS, name) ? SUBSCRIPTION_TIERS[name] : null;